<script>
	import Dispatch from '../Dispatcher'
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop, faForward, faBackward, faSolarSystem, faFire, faSparkles } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap } from 'rxjs/operators';
  import { withLatestFrom } from 'rxjs/operators';
  import _ from 'lodash'
import { combineLatest } from 'rxjs';

	let mouseStart = 0

  const scale = Dispatch.getState('view.scale')

	const selectedCommand = combineLatest(Dispatch.getState('layers'), Dispatch.getState('view.details.selected.id'))
		.pipe(
			map(([layers, selected]) => _.find(layers, command => command.id === selected)),
		)

  // const group = Dispatch.getState('view.groups')
  // .pipe(
  //   withLatestFrom(selectedCommand),
  //   map(e => _.find(e[0], group => group.id === e[1]?.lightgroup))
  // )


  const group = combineLatest(Dispatch.getState('view.groups'),selectedCommand)
  .pipe(
    map(e => _.find(e[0], group => group.id === e[1]?.lightgroup)),
  )

  const type = combineLatest(Dispatch.getState('view.types'),selectedCommand)
    .pipe(
      map(e => _.find(e[0], group => group.id === e[1]?.type)),
    )

  const option =  combineLatest(Dispatch.getState('view.special'),selectedCommand)
    .pipe(
      map(e => _.find(e[0], group => group.id === e[1]?.option)),
    )

const icons = {
  faSparkles: faSparkles,
  faFire: faFire,
  faSolarSystem: faSolarSystem
}
</script>

<div class='w-100 bg-moon-gray flex items-center justify-center black'
  on:click={e => e.stopPropagation()}
    style={'height:80px;'}>
      <div class='w-100 absolute flex items-center ' 
        style={'left: ' + (($scale.windowWidth / $scale.songLength) * $selectedCommand.position) + 'px; min-width: ' + (($scale.windowWidth / $scale.songLength) * $selectedCommand.width) + 'px'}>
        <div class='pl2 flex flex-column items-center'>
          <div class={'br3 pa2 ph3 white fw7 f6 bg-black' } on:click={e => Dispatch.nextAction('nextType', $selectedCommand)}><Fa icon={icons[$type.icon]}/> <span class='pl2'>{$type.name}</span> </div>
        </div>
        <div class='pl2 flex flex-column items-center'>
          <div class={'br3 pa2 white fw7 f6 ' + $group.style} on:click={e => Dispatch.nextAction('nextLightGroup', $selectedCommand)}>{$group.name}</div>
        </div>
        {#if $selectedCommand.type === 'spiral'}
          <div class='pl2 flex flex-column items-center'>
            <div class={'br3 pa2 ph3 white fw7 f6' + ($selectedCommand?.reverse ? ' bg-red ' : ' bg-green ')} on:click={ e => Dispatch.nextAction('changeLightDirection', $selectedCommand)}>Direction: 
              {#if $selectedCommand?.reverse }
                <Fa class='pl2' icon={faBackward}/>
                {:else}
                <Fa class='pl2' icon={faForward}/>
                {/if}
              </div>
          </div>
        {/if}
        <div class='pl2 flex flex-column items-center'>
          <div class={'br3 pa2 white fw7 f6 bg-green' } on:click={ e => Dispatch.nextAction('nextSpecial', $selectedCommand)}>
            {$option?.name}
          </div>
        </div>
        <div class='pl2 flex flex-column items-center'>
          <div class='br3 ph2 pv2 bg-green white f6 fw7' on:click={e => Dispatch.nextAction('awaitBind', true)}>{$selectedCommand?.keyBind?.code ? 'Key Bind: ' + $selectedCommand?.keyBind?.code : 'Bind Key'}</div>
        </div>
      </div>
    </div>

<style>
</style>